import { IAppState } from 'shared/common/state';

export function selectDetectedLocation(state: IAppState) {
  return state.detectedLocation;
}
